'use client';
import { fetchBlogs } from '@eliadmin/core/src/api/blogs/blogs-api';
import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';
import { CacheKey } from '@eliadmin/core/src/api/constants';
import { SearchBarBlog } from '@eliadmin/core/src/components/blog/search-bar/search-bar-blog';
import { SearchBar } from '@eliadmin/core/src/components/ui/search-bar';
import { useSearchBar } from '@eliadmin/core/src/hooks/search-bar/use-search-bar';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const BlogSearchBar = () => {
  const locale = useLocaleStore(s => s.currentLocale);

  const { items, isLoading, searchQuery, setSearchQuery } = useSearchBar({
    fetchFn: query => fetchBlogs({ locale, query: { results: 5, search: query } }),
    cacheKey: CacheKey.BLOGS,
    mapData: (data, debouncedSearch) =>
      data.data.map((blog: Blog & { id: number }) => (
        <SearchBarBlog key={`${blog.id}`} blog={blog} searchQuery={debouncedSearch} />
      )),
  });

  return (
    <SearchBar
      items={items}
      isLoading={isLoading}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    />
  );
};
